<template>
  <div class="introduction-container">
    <div class="logo-container">
      <img src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png" alt="" class="logo" />
    </div>
    <div class="text-container">
      <p>迈好第一步，见到新气象！</p>
      <p>
        站在“两个一百年”奋斗目标的历史交汇点上，江苏正在描摹“十四五”规划和二〇三五年远景目标的奋进蓝图，以高质量发展的过硬成果开辟未来。
      </p>
    </div>

    <div class="slogan-container">
      <img src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-1.png" alt="" class="slogan s1" />
      <img src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-2.png" alt="" class="slogan s2" />
      <img src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/slogan-3.png" alt="" class="slogan s3" />
    </div>

    <div class="bt" @click="jump">点击进入</div>
  </div>
</template>

<script>
export default {
  methods: {
    jump() {
      this.$router.replace("/thirteen-city");
    },
  },
};
</script>

<style scoped>
.logo-container {
}

.logo {
  margin-right: 4vw;
  margin-left: auto;
  display: block;
  width: 20vw;
}

.text-container {
  margin-top: 4vh;
  text-indent: 2em;
  font-size: 4.8vw;
  line-height: 8vw;
  font-family: FZZH;
  padding: 0 10vw;
  color: rgb(255, 222, 152);
  text-align: justify;
}

.slogan-container {
  margin-top: 6vh;
}

.slogan {
  width: 69vw;
  margin-bottom: 2.5vh;
  position: relative;
  display: block;
}

.s1 {
  left: 19.2vw;
  opacity: 0;
  animation: show-from-right 0.5s forwards ease-in;
  animation-delay: 0.5s;
}

.s2 {
  left: 39.5vw;
  opacity: 0;
  animation: show-from-right 0.5s forwards ease-in;
  animation-delay: 1s;
}

.s3 {
  left: 29.3vw;
  opacity: 0;
  animation: show-from-right 0.5s forwards ease-in;
  animation-delay: 1.5s;
}

.bt {
  margin: 7vh auto 0;
  width: 120px;
  height: 32px;
  background: #ffde98;
  box-shadow: 0px 1px 6px 0px rgba(104, 1, 1, 0.64);
  border-radius: 16px;
  color: #990100;
  line-height: 32px;
  text-align: center;
  font-size: 15px;
}

@keyframes show-from-right {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@media screen and (min-width: 640px) {
  .logo {
    margin-right: 40px;
    margin-left: auto;
    display: block;
    width: 128px;
  }

  .text-container {
    font-size: 20px;
    line-height: 30px;
    padding: 0 64px;
  }

  .slogan {
    width: 448px;
  }

  .s1 {
    left: 121px;
  }

  .s2 {
    left: 256px;
  }

  .s3 {
    left: 192px;
  }

  .bt {
    width: 220px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    border-radius: 30px;
  }
}

@media screen and (max-height: 700px) {
  .slogan {
    width: 60vw;
    margin-bottom: 2vh;
  }

  .bt {
    margin: 5vh auto 0;
  }
}
</style>